import React, { Component, Fragment } from 'react';
import { Card, Grid, Icon, Button, Modal, Header } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';
import shortid from 'shortid';
import { get } from 'lodash';

import {
  clearCaseInfo,
  forceRecalculate,
  writeVerifyAction,
} from '../../state/hub/actions';

import { CheckboxField, TextLabelField } from 'Common/SemanticWrapper';
import { APPLICATION_HUB_HEADER_FORM_NAME } from 'Common/FormEnum';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import {
  MemberTypeEnum,
  getCaseInfoExists,
  hasOneDCStudent,
} from '../../helpers/Helpers';
import { YesNoDialog } from 'Components';
import { DateDialog } from './DateDialog';
import { NotificationDialog } from 'Components/';
import { deleteApplication } from '../../state/manageapplication/actions';
import {
  VerifyAction,
  SecondReviewResultEnumeration,
} from '../../helpers/Constants';
import 'PageStyles/manageapplication/index.less';

class HubHeader extends Component {
  state = {
    showConfirmUndoDialog: false,
    showApplicationDateDialog: false,
    showConfirmDeclineDialog: false,
    showIncompleteDialog: false,
    showDCIncompleteMessage: false,
    showDeleteModal: false,
  };

  componentDidUpdate(prevProps) {
    const { change, appModifiedByUser, tempApplication } = this.props;

    if (
      prevProps.appModifiedByUser !== appModifiedByUser &&
      tempApplication.ApplicationInformation.SecondReviewResultId ===
        SecondReviewResultEnumeration.NoChange
    ) {
      change(Fields.SecondReviewMarkAsNoChange, false);
    }
  }

  onUndoChangesClick = () => {
    this.setState({ showConfirmUndoDialog: true });
  };

  onConfirmUndo = () => {
    toast.dismiss();
    this.props.fetchApp();
    this.setState({ showConfirmUndoDialog: false });
  };

  onCancelUndo = () => {
    this.setState({ showConfirmUndoDialog: false });
  };

  onConfirmDecline = () => {
    const { change } = this.props;
    this.setState({ showConfirmDeclineDialog: false });
    change(Fields.IsReducedBenefits, false);
    change(Fields.IsIncomplete, false);
    this.props.forceRecalculate();
  };

  onCancelDecline = () => {
    const { change } = this.props;
    change(Fields.IsDeclinedBenefits, false);
    this.setState({ showConfirmDeclineDialog: false });
  };

  onCancelIncomplete = () => {
    const { change } = this.props;
    change(Fields.IsIncomplete, false);
    this.setState({ showIncompleteDialog: false });
  };

  onDCWarningIncomplete = () => {
    const { change } = this.props;
    this.setState({ showDCIncompleteMessage: false });
    change(Fields.IsIncomplete, false);
  };

  onConfirmIncomplete = () => {
    this.setState({ showIncompleteDialog: false });
    this.props.forceRecalculate();
  };

  onApplicationDateClick = () => {
    this.setState({ showApplicationDateDialog: true });
  };

  onDeleteAppClick = () => {
    this.setState({ showDeleteModal: true });
  };

  closeDeleteModal = () => {
    this.setState({ showDeleteModal: false });
  };

  onConfirmDelete = (deleteStudents) => () => {
    const { initialValues } = this.props;
    this.props.deleteApplication(
      initialValues.FamilyNumber,
      deleteStudents,
      null,
      true
    );
    this.setState({ showDeleteModal: false });
  };

  onCompleteApplicationDate = () => {
    this.setState({ showApplicationDateDialog: false });
  };

  onCloseSecondReviewStatusChangeDialog = () => {
    const { setShowSecondReviewStatusChangeDialog, change } = this.props;

    change(Fields.SecondReviewCategoricalEligibilityError, false);
    change(Fields.SecondReviewGrossIncomeCalculationError, false);
    change(Fields.SecondReviewOtherError, false);
    setShowSecondReviewStatusChangeDialog(false);
  };

  onConfirmSecondReviewStatusChangeDialog = () => {
    const {
      setShowSecondReviewStatusChangeDialog,
      setSecondReviewResultRecorded,
      onApplicationSaveClick,
    } = this.props;
    setShowSecondReviewStatusChangeDialog(false);
    setSecondReviewResultRecorded(true);
    onApplicationSaveClick();
  };

  onBenefitsChange = (isChecked, checkedField) => {
    const { change } = this.props;

    if (checkedField === Fields.IsDeclinedBenefits) {
      if (isChecked) {
        //only recalc if answer yes to prompt
        this.setState({ showConfirmDeclineDialog: true });
      } else {
        //always re-calc
        this.props.forceRecalculate();
      }
    }

    if (checkedField === Fields.IsIncomplete) {
      if (isChecked) {
        //if any students are dc show message
        if (hasOneDCStudent(this.props.students)) {
          this.setState({ showDCIncompleteMessage: true });
        } else {
          this.setState({ showIncompleteDialog: true });
        }
      } else {
        //always re-calc
        this.props.forceRecalculate();
      }
    }

    //check / uncheck logic
    if (isChecked) {
      switch (checkedField) {
        case Fields.IsReducedBenefits: {
          change(Fields.IsDeclinedBenefits, false);
          change(Fields.IsIncomplete, false);
          this.props.forceRecalculate();
          break;
        }
        case Fields.IsIncomplete: {
          change(Fields.IsDeclinedBenefits, false);
          change(Fields.IsReducedBenefits, false);
          break;
        }
        default:
          break;
      }
    }
  };

  onSecondReviewActionChange = (isChecked, checkedField) => {
    const { change, forceRecalculate } = this.props;
    if (isChecked) {
      switch (checkedField) {
        case Fields.SecondReviewMarkAsNoChange: {
          change(Fields.SecondReviewMarkAsIncomplete, false);
          forceRecalculate();
          break;
        }
        case Fields.SecondReviewMarkAsIncomplete: {
          change(Fields.SecondReviewMarkAsNoChange, false);
          forceRecalculate();
          break;
        }
        case Fields.SecondReviewGrossIncomeCalculationError: {
          change(Fields.SecondReviewCategoricalEligibilityError, false);
          change(Fields.SecondReviewOtherError, false);
          break;
        }
        case Fields.SecondReviewCategoricalEligibilityError: {
          change(Fields.SecondReviewOtherError, false);
          change(Fields.SecondReviewGrossIncomeCalculationError, false);
          break;
        }
        case Fields.SecondReviewOtherError: {
          change(Fields.SecondReviewCategoricalEligibilityError, false);
          change(Fields.SecondReviewGrossIncomeCalculationError, false);
          break;
        }
        default:
          break;
      }
    } else {
      switch (checkedField) {
        case Fields.SecondReviewMarkAsNoChange: {
          change(Fields.SecondReviewMarkAsNoChange, false);
          forceRecalculate();
          break;
        }
        case Fields.SecondReviewMarkAsIncomplete: {
          change(Fields.SecondReviewMarkAsIncomplete, false);
          forceRecalculate();
          break;
        }
        case Fields.SecondReviewGrossIncomeCalculationError: {
          change(Fields.SecondReviewGrossIncomeCalculationError, false);
          break;
        }
        case Fields.SecondReviewCategoricalEligibilityError: {
          change(Fields.SecondReviewCategoricalEligibilityError, false);
          break;
        }
        case Fields.SecondReviewOtherError: {
          change(Fields.SecondReviewOtherError, false);
          break;
        }
        default:
          break;
      }
    }
  };

  navigateTo(e, memberType) {
    const { history } = this.props;

    const queryString = get(history, 'location.search', '');

    e.preventDefault();
    const familyNumber = this.props.initialValues
      ? this.props.initialValues.FamilyNumber
      : null;
    switch (memberType) {
      case MemberTypeEnum.HOH:
        this.props.history.push(
          `/manageapplication/${familyNumber}/hoh${queryString}`
        );
        break;

      case MemberTypeEnum.Student:
        this.props.history.push(
          `/manageapplication/${familyNumber}/studentlookup${queryString}`
        );
        break;

      case MemberTypeEnum.Member:
        this.props.history.push(
          `/manageapplication/${familyNumber}/member/member_${shortid.generate()}${queryString}`
        );
        break;

      default:
        break;
    }
  }

  formatFamilyNumber = (value) => {
    return value === 0 ? 'TBD' : value;
  };

  getDialogs = () => [
    {
      key: 0,
      showDialog: this.state.showConfirmUndoDialog,
      title: 'Undo Changes',
      question: `Are you sure you want to undo all of your changes to this application? This action cannot be reversed.`,
      yesCallback: this.onConfirmUndo,
      noCallback: this.onCancelUndo,
    },
    {
      key: 1,
      showDialog: this.state.showConfirmDeclineDialog,
      title: 'Decline Benefits',
      question: () => {
        return (
          <Fragment>
            By selecting decline benefits for this application, all students
            will be set to a paid status (4). <br />
            <br />
            Are you sure?
          </Fragment>
        );
      },
      yesCallback: this.onConfirmDecline,
      noCallback: this.onCancelDecline,
    },
    {
      key: 2,
      showDialog: this.state.showIncompleteDialog,
      title: 'Incomplete Application',
      question: () => {
        return (
          <Fragment>
            Are you sure you want to set this application to incomplete?
            <br />
            <br />
            Household, member, and income information entered will be saved, but
            student status information will not be updated/calculated.
          </Fragment>
        );
      },
      yesCallback: this.onConfirmIncomplete,
      noCallback: this.onCancelIncomplete,
    },
  ];

  render() {
    const {
      applicationDate,
      applicationDatePickerProps,
      appModifiedByUser,
      caseInfoExists,
      changeApplicationDate,
      clearCaseInfo,
      hasHOH,
      hasStudents,
      isNewApp,
      isSecondReview,
      isSelectedForVerification,
      isVerification,
      secondReviewResultId,
      showSecondReviewStatusChangeDialog,
      verificationComplete,
      verificationMessage,
      verificationSelectionLetterPrinted,
      writeVerifyAction,
    } = this.props;

    const familyNumber = this.props.initialValues
      ? this.props.initialValues.FamilyNumber
      : null;

    const { showDeleteModal } = this.state;
    return (
      <Fragment>
        {this.getDialogs().map((dialog) => (
          <YesNoDialog {...dialog} />
        ))}
        <NotificationDialog
          title={'Application contains Direct Certified students'}
          showDialog={this.state.showDCIncompleteMessage}
          message={
            'Application contains 1 or more Direct Certified students and cannot be set as incomplete.'
          }
          onOkClick={this.onDCWarningIncomplete}
        />

        <DateDialog
          buttonText={'Set Date'}
          datePickerProps={applicationDatePickerProps}
          onCancel={this.onCompleteApplicationDate}
          onChange={changeApplicationDate}
          onComplete={this.onCompleteApplicationDate}
          open={this.state.showApplicationDateDialog}
          title={'Set Application Date'}
          value={applicationDate}
        />
        <Modal size="small" open={showSecondReviewStatusChangeDialog}>
          <Header icon="info circle" content={'Second Review Status Change'} />
          <Modal.Content>
            <div className={'second-review-modal-content'}>
              <Grid>
                <Grid.Row>
                  <label className={'second-review-modal-label'}>
                    The status of the application has changed. Please choose one
                    of the options listed below to indicate why the status has
                    changed.
                  </label>
                </Grid.Row>
                <Grid.Row>
                  <Field
                    component={CheckboxField}
                    label={'Gross Income Calculation Error'}
                    name={Fields.SecondReviewGrossIncomeCalculationError}
                    className={'second-review-modal-label'}
                    onChange={(e, data) =>
                      this.onSecondReviewActionChange(
                        data,
                        Fields.SecondReviewGrossIncomeCalculationError
                      )
                    }
                  />
                </Grid.Row>
                <Grid.Row>
                  <Field
                    component={CheckboxField}
                    label={'Categorical Eligibility Error'}
                    name={Fields.SecondReviewCategoricalEligibilityError}
                    className={'second-review-modal-label'}
                    onChange={(e, data) =>
                      this.onSecondReviewActionChange(
                        data,
                        Fields.SecondReviewCategoricalEligibilityError
                      )
                    }
                  />
                </Grid.Row>
                <Grid.Row>
                  <Field
                    component={CheckboxField}
                    name={Fields.SecondReviewOtherError}
                    label={'Other Error'}
                    className={'second-review-modal-label'}
                    onChange={(e, data) =>
                      this.onSecondReviewActionChange(
                        data,
                        Fields.SecondReviewOtherError
                      )
                    }
                  />
                </Grid.Row>
              </Grid>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.onCloseSecondReviewStatusChangeDialog}>
              Close
            </Button>
            <Button
              className={'second-review-modal-continue'}
              disabled={secondReviewResultId === null}
              onClick={this.onConfirmSecondReviewStatusChangeDialog}
            >
              Continue
            </Button>
          </Modal.Actions>
        </Modal>
        <Card.Group itemsPerRow={3}>
          <Card raised>
            <Card.Content>
              <Card.Header textAlign={'center'}>
                <Field
                  component={TextLabelField}
                  name={Fields.ApplicationName}
                  disabled={true}
                />
              </Card.Header>
              <Card.Description>
                <Grid className={'manage-application--household-card-grid'}>
                  <Grid.Row columns={'equal'}>
                    <Grid.Column>
                      <strong>Family Number:</strong>
                    </Grid.Column>
                    <Grid.Column>
                      <Field
                        name={Fields.FamilyNumber}
                        component={TextLabelField}
                        format={this.formatFamilyNumber}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={'equal'}>
                    <Grid.Column>
                      <strong>Status:</strong>
                    </Grid.Column>
                    <Grid.Column>
                      <Field
                        disabled
                        component={TextLabelField}
                        name={Fields.ActiveStatus}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={'equal'}>
                    <Grid.Column>
                      <strong>Application Date:</strong>
                    </Grid.Column>
                    <Grid.Column>
                      <List.Item
                        as={'a'}
                        disabled={isSelectedForVerification}
                        onClick={this.onApplicationDateClick}
                      >
                        {defaultDateFormat(applicationDate)}
                      </List.Item>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={'equal'}>
                    <Grid.Column>
                      <strong>Total Income:</strong>
                    </Grid.Column>
                    <Grid.Column>{this.props.income}</Grid.Column>
                  </Grid.Row>
                  {verificationMessage ? (
                    <Grid.Row columns={'equal'}>
                      <Grid.Column>
                        <strong>Verification Status:</strong>
                      </Grid.Column>
                      <Grid.Column className={'text-red'}>
                        <Icon name={'exclamation triangle'} />
                        {verificationMessage}
                      </Grid.Column>
                    </Grid.Row>
                  ) : undefined}
                </Grid>
              </Card.Description>
            </Card.Content>
          </Card>
          <Card raised>
            <Card.Content>
              <Card.Header textAlign={'center'}>Actions</Card.Header>
              <Card.Description>
                <List>
                  <List.Item
                    as={'a'}
                    onClick={(e) => {
                      if (isSecondReview) {
                        this.onSecondReviewActionChange(
                          false,
                          Fields.SecondReviewMarkAsNoChange
                        );
                      }
                      this.navigateTo(e, MemberTypeEnum.Student);
                    }}
                  >
                    <List.Icon name={'student'} />
                    <List.Content>Add Student</List.Content>
                  </List.Item>
                  <List.Item
                    as={'a'}
                    onClick={(e) => {
                      if (isSecondReview) {
                        this.onSecondReviewActionChange(
                          false,
                          Fields.SecondReviewMarkAsNoChange
                        );
                      }
                      this.navigateTo(e, MemberTypeEnum.HOH);
                    }}
                    disabled={hasHOH || !hasStudents}
                  >
                    <List.Icon name={'home'} />
                    <List.Content
                      className={'manage-application--action-padding'}
                    >
                      Add Head of Household
                    </List.Content>
                  </List.Item>
                  <List.Item
                    as={'a'}
                    onClick={(e) => {
                      if (isSecondReview) {
                        this.onSecondReviewActionChange(
                          false,
                          Fields.SecondReviewMarkAsNoChange
                        );
                      }
                      this.navigateTo(e, MemberTypeEnum.Member);
                    }}
                    disabled={!hasStudents}
                  >
                    <List.Icon name={'user outline'} />
                    <List.Content
                      className={'manage-application--action-padding'}
                    >
                      Add Member
                    </List.Content>
                  </List.Item>
                  <List.Item
                    as={'a'}
                    onClick={clearCaseInfo}
                    disabled={!caseInfoExists}
                  >
                    <List.Icon name={'remove'} />
                    <List.Content
                      className={'manage-application--action-padding'}
                    >
                      Clear All Case Information
                    </List.Content>
                  </List.Item>
                  <List.Item
                    as={'a'}
                    onClick={this.onUndoChangesClick}
                    disabled={!appModifiedByUser || isNewApp}
                  >
                    <List.Icon name={'undo'} />
                    <List.Content
                      className={'manage-application--action-padding'}
                    >
                      Undo Changes
                    </List.Content>
                  </List.Item>
                  {!(
                    this.props.applicationData &&
                    this.props.applicationData.ApplicationInformation &&
                    this.props.applicationData.ApplicationInformation
                      .VerificationStatus !== '0'
                  ) ? (
                    <List.Item
                      as={'a'}
                      onClick={this.onDeleteAppClick}
                      disabled={isNewApp}
                    >
                      <List.Icon name={'trash'} />
                      <List.Content
                        className={'manage-application--action-padding'}
                      >
                        Delete Application
                      </List.Content>
                    </List.Item>
                  ) : undefined}
                </List>
              </Card.Description>
            </Card.Content>
          </Card>
          {isSecondReview ? (
            <Card raised>
              <Card.Content>
                <Card.Header textAlign={'center'}>
                  Second Review Options
                </Card.Header>
                <Card.Description>
                  <Field
                    component={CheckboxField}
                    label={'Mark as No Change'}
                    name={Fields.SecondReviewMarkAsNoChange}
                    onChange={(e, data) =>
                      this.onSecondReviewActionChange(
                        data,
                        Fields.SecondReviewMarkAsNoChange
                      )
                    }
                  />
                  <Field
                    component={CheckboxField}
                    label={'Mark as Incomplete'}
                    name={Fields.SecondReviewMarkAsIncomplete}
                    onChange={(e, data) =>
                      this.onSecondReviewActionChange(
                        data,
                        Fields.SecondReviewMarkAsIncomplete
                      )
                    }
                  />
                </Card.Description>
              </Card.Content>
            </Card>
          ) : verificationSelectionLetterPrinted &&
            isSelectedForVerification &&
            !isSecondReview ? (
            <Card raised>
              <Card.Content>
                <Card.Header textAlign={'center'}>
                  Verification Options
                </Card.Header>
                <Card.Description>
                  <List>
                    <List.Item
                      as={'a'}
                      disabled={!isVerification || verificationComplete}
                      onClick={() => {
                        writeVerifyAction(
                          familyNumber,
                          VerifyAction.DirectlyVerified
                        );
                      }}
                    >
                      <List.Icon name={'check'} />
                      <List.Content>Directly Verified</List.Content>
                    </List.Item>
                    <List.Item
                      as={'a'}
                      disabled={!isVerification || verificationComplete}
                      onClick={() => {
                        writeVerifyAction(
                          familyNumber,
                          VerifyAction.VerifyNoChange
                        );
                      }}
                    >
                      <List.Icon name={'check'} />
                      <List.Content>Verify No Change</List.Content>
                    </List.Item>
                    <List.Item
                      as={'a'}
                      disabled={!isVerification || verificationComplete}
                      onClick={() => {
                        writeVerifyAction(
                          familyNumber,
                          VerifyAction.DenyIncomplete
                        );
                      }}
                    >
                      <List.Icon name={'cancel'} />
                      <List.Content>Deny as Incomplete</List.Content>
                    </List.Item>
                    <List.Item
                      as={'a'}
                      disabled={!isVerification || verificationComplete}
                      onClick={() => {
                        writeVerifyAction(
                          familyNumber,
                          VerifyAction.DenyNoResponse
                        );
                      }}
                    >
                      <List.Icon name={'cancel'} />
                      <List.Content>Deny as No Response</List.Content>
                    </List.Item>
                    <List.Item
                      as={'a'}
                      disabled={!isVerification || verificationComplete}
                      onClick={() => {
                        writeVerifyAction(
                          familyNumber,
                          VerifyAction.HouseholdDeclined
                        );
                      }}
                    >
                      <List.Icon name={'cancel'} />
                      <List.Content>Household Declined</List.Content>
                    </List.Item>
                  </List>
                </Card.Description>
              </Card.Content>
            </Card>
          ) : (
            <Card raised>
              <Card.Content>
                <Card.Header textAlign={'center'}>
                  Application Options
                </Card.Header>
                <Card.Description>
                  <Field
                    component={CheckboxField}
                    label={'Declined Benefits'}
                    name={Fields.IsDeclinedBenefits}
                    onChange={(e, data) =>
                      this.onBenefitsChange(data, Fields.IsDeclinedBenefits)
                    }
                  />
                  {/* <Field
                    component={CheckboxField}
                    label={'Reduced Benefits'}
                    name={Fields.IsReducedBenefits}
                    onChange={(e, data) =>
                      this.onBenefitsChange(data, Fields.IsReducedBenefits)
                    }
                  /> */}
                  <Field
                    component={CheckboxField}
                    label={'Incomplete Application'}
                    name={Fields.IsIncomplete}
                    onChange={(e, data) =>
                      this.onBenefitsChange(data, Fields.IsIncomplete)
                    }
                  />
                </Card.Description>
              </Card.Content>
            </Card>
          )}
        </Card.Group>
        <YesNoDialog
          showDialog={showDeleteModal}
          title={'Delete students from Point of Sale?'}
          question={
            <span>
              Do you also want to delete students associated with this
              application from Point of Sale?
              <br />
              This action can not be undone.
            </span>
          }
          yesCallback={this.onConfirmDelete(true)}
          noCallback={this.onConfirmDelete(false)}
          cancelCallback={this.closeDeleteModal}
          showCancel
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { Students } = state.ManageApplicationState.hub.tempApplication;

  return {
    members: state.ManageApplicationState.hub.tempApplication.Members,
    showSecondReviewStatusChangeDialog:
      state.ManageApplicationState.hub.showSecondReviewStatusChangeDialog,
    caseInfoExists: getCaseInfoExists(Students),
    students: Students,
    secondReviewResultId: get(
      state.ManageApplicationState.hub.tempApplication.ApplicationInformation,
      'SecondReviewResultId',
      null
    ),
    tempApplication: state.ManageApplicationState.hub.tempApplication,
    isVerification: state.ManageApplicationState.hub.isVerification,
  };
};

HubHeader = withRouter(
  connect(mapStateToProps, {
    clearCaseInfo,
    forceRecalculate,
    deleteApplication,
    writeVerifyAction,
  })(HubHeader)
);

HubHeader = reduxForm({
  form: APPLICATION_HUB_HEADER_FORM_NAME,
  destroyOnUnmount: true,
})(HubHeader);

export { HubHeader };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/hub/HubHeader.js